module.exports = __webpack_public_path__ + "materialdesignicons-webfont.a65b9561e6b00796ee6a.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.ttf?v=1.8.36
// module id = ../../../../../src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.ttf?v=1.8.36
// module chunks = styles